
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Layer 1","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M44.61 4.82a2 2 0 00-2.61.95L18.45 56.6a1.93 1.93 0 00.94 2.57 1.88 1.88 0 00.57.17 1.93 1.93 0 002-1.11L45.55 7.4a2 2 0 00-.94-2.58zM20.39 35.76a2 2 0 00.19-1.47 2 2 0 00-.91-1.18L7.31 26a1 1 0 01-.52-.89 1 1 0 01.51-.89l12.4-7.35a2 2 0 00.88-1.19 1.93 1.93 0 00-1.39-2.35 1.66 1.66 0 00-.49-.07 1.92 1.92 0 00-1 .28L1 23.48a1.93 1.93 0 000 3.34l16.77 9.65a2 2 0 002.62-.71zm42.66 1.72l-16.77-9.94a2 2 0 00-1-.27 1.94 1.94 0 00-1 3.6l12.4 7.35a1 1 0 010 1.79l-12.35 7.11a1.94 1.94 0 00-.72 2.64 2 2 0 002.65.72L63 40.83a1.94 1.94 0 000-3.35z"}})])
          )
        }
      }
    